import { useEffect, useState } from 'react';
const countryDialCodes = require('constants/country-dial-codes.json')
  .map(opt => ({
    value: opt.dial_code,
    translation: opt.dial_code,
    code: opt.code,
    pattern: opt.pattern,
  }))
  .sort((a, b) => {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  });

export const usePhoneNumberCode = ({
  countrySelected,
  defaultCountryCode = 'ES',
  phoneCountryCodeName,
  setValue,
}) => {
  const [pattern, setPattern] = useState();
  const handleChange = e => {
    setPattern(
      countryDialCodes.find(opt => opt.value === e.target.value).pattern,
    );
  };
  useEffect(() => {
    if (!countrySelected) {
      const selected = countryDialCodes.find(
        opt => opt.code === defaultCountryCode,
      );
      setValue(phoneCountryCodeName, selected.value);
      setPattern(selected.pattern);
    } else {
      setPattern(
        countryDialCodes.find(opt => opt.value === countrySelected).pattern,
      );
    }
  }, [setValue, phoneCountryCodeName, countrySelected, defaultCountryCode]);
  return { countryDialCodes, pattern, handleChange };
};
